import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import cx from "classnames";
import React, { useCallback, useContext, useEffect, useState } from "react";

import Guide from "components/Guide";
import ShotContext from "components/Shot/ShotContext";
import { SERVICES, UserGuides, WINDOW_EVENTS } from "constants/constants";

import styles from "./CameraTrack.module.scss";

export const CameraTrack = () => {
  const {
    selectedShot,
    service,
    layers,
    layerId,
    shotCutouts,
    setSelectedLayer,
    setShowTrackingPanel,
  } = useContext(ShotContext);

  const addKeyFrame = useCallback(
    (e) => {
      window.removeEventListener(
        WINDOW_EVENTS.CURRENT_FRAME_REPLY,
        addKeyFrame,
      );

      let frame = (e as CustomEvent)?.detail?.frame as number | undefined;
      if (frame === undefined || !selectedShot) return;
      frame += selectedShot.first_frame_number;

      const frameCutouts = shotCutouts.filter((c) => c.frame === frame);
      if (frameCutouts.length) {
        const layer = layers?.find((l) => l.id === frameCutouts[0].layer_id);
        if (layer) {
          setSelectedLayer(layer);
        } else {
          setSelectedLayer(null);
        }
      } else {
        setSelectedLayer(null);
      }

      window.dispatchEvent(
        new CustomEvent(WINDOW_EVENTS.ANNOTATE, {
          detail: {
            frame,
          },
        }),
      );
    },
    [layers, selectedShot, setSelectedLayer, shotCutouts],
  );

  if (!selectedShot || service !== SERVICES.TRACKING) return null;

  return (
    <Guide
      id={UserGuides.AddKeyframe}
      open={layers !== undefined && !layers.length}
      placement="left"
      title="Start your first camera track"
      description="Start by clicking Track Camera"
    >
      <Button
        className={cx(styles.annotateButton, "slapShotButton")}
        variant="contained"
        onClick={() => {
          setShowTrackingPanel(true);
        }}
        color="secondary"
        size="small"
        sx={{
          ".MuiSvgIcon-root": {
            width: "14px",
            height: "14px",
          },
        }}
      >
        <AddIcon /> Track Camera
      </Button>
    </Guide>
  );
};
